import {
  BTM,
  CHOICE,
  CHOICE_NAME,
  CORE,
  CORE_NAME,
  DELUXE,
  DELUXE_NAME,
  DENTAL,
  DENTAL_NAME,
  DENTAL_STAND_ALONE,
  ECONOMY,
  ECONOMY_NAME,
  EPIC_BASE,
  EPIC_BASE_NAME,
  EPIC_PPO,
  EPIC_PPO_NAME,
  FIXED,
  LATITUDE,
  LATITUDE_NAME,
  QUANTUM,
  QUANTUM_NAME,
  STANDARD,
  STANDARD_NAME,
  VISION,
  VISION_NAME,
  SURE_CARE,
  SURE_CARE_NAME
} from 'core/constants/products'
import isEpicPlan from '../plan/isEpicPlan'
import isPlanPPO from '../plan/isPlanPPO'

const PRODUCTS = {
  [DENTAL]: DENTAL_NAME,
  [VISION]: VISION_NAME,
  [ECONOMY]: ECONOMY_NAME,
  [QUANTUM]: QUANTUM_NAME,
  [DELUXE]: DELUXE_NAME,
  [STANDARD]: STANDARD_NAME,
  [CORE]: CORE_NAME,
  [CHOICE]: CHOICE_NAME,
  [EPIC_PPO]: EPIC_PPO_NAME,
  [EPIC_BASE]: EPIC_BASE_NAME,
  [DENTAL_STAND_ALONE]: 'DENTAL_ALONE',
  [FIXED]: 'FBM',
  [BTM]: 'BRIDGE_TO_MEDICARE',
  [LATITUDE]: LATITUDE_NAME,
  [SURE_CARE]: SURE_CARE_NAME
}

export function getProductTypeName<T extends Plan>(plan: T): string {
  const productName: string = PRODUCTS[plan.productId]

  if (productName) {
    return productName
  }

  if (isEpicPlan(plan)) {
    return isPlanPPO(plan) ? EPIC_PPO_NAME : EPIC_BASE_NAME
  }

  return ''
}

export function findProductTypeNames<T extends CorePlan>(plans: T[]): string[] {
  const productTypeNames = Object.keys(plans)
    .map(planId => getProductTypeName(plans[planId]).toUpperCase())
    .filter(Boolean)

  return [...new Set(productTypeNames)]
}
